import React from 'react';
import { Navigation } from './components/Navigation';
import { MobileBottomBar } from './components/MobileBottomBar';
import { Footer } from './components/Footer';
import { Hero } from './components/sections/Hero';
import { TrustStrip } from './components/sections/TrustStrip';
import { Difference } from './components/sections/Difference';
import { DisplayHome } from './components/sections/DisplayHome';
import { CompletedHomes } from './components/sections/CompletedHomes';
import { Awards } from './components/sections/Awards';
import { Process } from './components/sections/Process';
import { Communication } from './components/sections/Communication';
import { Team } from './components/sections/Team';
import { ObjectionKiller } from './components/sections/ObjectionKiller';
import { Testimonials } from './components/sections/Testimonials';
import { FAQ } from './components/sections/FAQ';
import { FinalCTA } from './components/sections/FinalCTA';
import { Enquire } from './components/sections/Enquire';
export function App() {
  return <div className="min-h-screen flex flex-col" data-id="element-0">
      <Navigation data-id="element-1" />

      <main className="flex-grow pb-16 md:pb-0" data-id="element-2">
        <Hero data-id="element-3" />
        <TrustStrip data-id="element-4" />
        <Difference data-id="element-5" />
        <DisplayHome data-id="element-6" />
        <CompletedHomes data-id="element-7" />
        <Awards data-id="element-8" />
        <Process data-id="element-9" />
        <Communication data-id="element-10" />
        <Team data-id="element-11" />
        <ObjectionKiller data-id="element-12" />
        <Testimonials data-id="element-13" />
        <FAQ data-id="element-14" />
        <FinalCTA data-id="element-15" />
        <Enquire data-id="element-16" />
      </main>

      <Footer data-id="element-17" />
      <MobileBottomBar data-id="element-18" />
    </div>;
}